module.exports = __webpack_public_path__ + "img/6.bbb4bc00.jpg";